export const ASSETS_BUCKET = 'https://caddy-stats-assets.nyc3.digitaloceanspaces.com/';

export const getImageUrl = (path: string) => `${ASSETS_BUCKET}${path}`;
